// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1eXZO","options":"AnswerScale_options__3HTkU","selected":"AnswerScale_selected__3B2O0"};